import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import PropTypes from 'prop-types';
import AlertConversationsTabContent from '../../AlertConversations/AlertConversationsTabContent';
import InfiniteScrollAlertHistory from '../../InfiniteScrollAlertHistory/InfiniteScrollAlertHistory';
import AlertActionsTabContent from '../AlertActions/AlertActionsTabContent';
import styles from './AlertDetailsNavTabs.module.css';

function AlertDetailsNavTabs({
  dispatchModalAction,
  hasAdvancedAlerting,
}) {
  return (
    <div className="row align-content-center my-3">
      <div className={styles.alertCardsCol}>
        <div className="ml-2 mt-1 mb-3">Actions</div>
        <div style={{ borderRadius: '.75rem' }}>
          <AlertActionsTabContent
            dispatchModalAction={dispatchModalAction}
            hasAdvancedAlerting={hasAdvancedAlerting}
          />
        </div>
      </div>

      <div className={styles.alertCardsCol}>
        <Tabs
          defaultActiveKey="conversation"
          id="conversation-history-tabs"
          justify
        >
          <Tab
            tabClassName={styles.customNavTab}
            eventKey="conversation"
            title="Conversation"
          >
            <div className="border border-1 border-top-0">
              <AlertConversationsTabContent />
            </div>
          </Tab>

          <Tab
            tabClassName={styles.customNavTab}
            eventKey="history"
            title="History"
          >
            <div className="border border-1 border-top-0 container-fluid overflow-auto py-2">
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                height: 595,
              }}
              >
                <InfiniteScrollAlertHistory />
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}
AlertDetailsNavTabs.propTypes = {
  users: PropTypes.shape({
    users: PropTypes.arrayOf(
      PropTypes.shape({
        userId: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
      }),
    ),
  }).isRequired,
  dispatchModalAction: PropTypes.func.isRequired,
  hasAdvancedAlerting: PropTypes.bool.isRequired,
};
export default AlertDetailsNavTabs;
